import Config from 'netxcore@netx/core-app/config';

Object.assign(Config, {
	CSS_CUSTOM_PROPERTY_PREFIX: '--mdc-theme-',
	CSS_CUSTOM_PROPERTIES: {
		'light-primary': '#cccccc',
		'light-on-primary': '#ffffff',

		'light-secondary': '#cccccc',
		'light-on-secondary': '#ffffff',

		'dark-primary': '#cccccc',
		'dark-on-primary': '#ffffff',

		'dark-secondary': '#cccccc',
		'dark-on-secondary': '#ffffff',
	},
	PASSIVE_ALERT_DELAY: 3000,
});

export default Config;
